import { hideLoader, showLoader } from "../Slices/loadingSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GlobalService, HttpService, parseApiErrors } from "../../modules";
import { CompanyFormData } from "../../modules/user/models";
import axios from "axios";
import { getLanguageHeaders } from "../../utils/languageHeaders";
import i18n from "../../i18n";

export const createUserPreferences = createAsyncThunk<any, { data: any }>(
    "client/createUserPreferences",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/user-preferences",
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.preferences.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User created Preferences failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateUserPreferences = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserPreferences",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.patch(
                `api/v1/user-preferences/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.preferences.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Preferences failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserPreferences = createAsyncThunk<any, { id: string; isShowLoader?: boolean }>(
    "client/getUserPreferences",
    async ({ id, isShowLoader = true }, { dispatch, rejectWithValue }) => {
        try {
            if (isShowLoader) {
                dispatch(showLoader());
            }
            const response = await HttpService.get(
                `api/v1/user-preferences/user/${id}`,

                true,
                {}
            );
            if (isShowLoader) {
                dispatch(hideLoader());
            }
            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }

            // GlobalService.showToast("success", "Success", "User Preferences Updated Successfully");
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Getting Preferences failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
// In your ClientActions file
export const validateVATNumber = createAsyncThunk(
    "client/validateVAT",
    async ({ countryCode, vatNumber, companyId }: { countryCode: string; vatNumber: string; companyId?: string }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/companies/validate-vat?countryCode=${countryCode}&vatNumber=${vatNumber}`,
                true,
                { "x-custom-lang": "en" }
            );
            // If validation is successful and companyId is provided, update the company
            if (response && response.valid && companyId) {
                // Use the existing updateUserCompanies action to ensure state updates properly
                await dispatch(updateUserCompanies({
                    id: companyId,
                    data: { 
                        isVatValid: true, 
                        vatNumber: countryCode + vatNumber
                    }
                })).unwrap();
            }

            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.vatNumber || errorData?.countryCode || "VAT validation failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserCompany = createAsyncThunk<any, { data: any }>(
    "client/createUserCompany",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/companies",
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());
            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.companies.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User created company failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserCompanies = createAsyncThunk<any, { id: string; isShowLoader?: boolean }>(
    "client/getUserCompanies",
    async ({ id, isShowLoader = true }, { dispatch, rejectWithValue }) => {
        try {
            if (isShowLoader) {
                dispatch(showLoader());
            }
            const response = await HttpService.get(
                `api/v1/companies/user/${id}`,

                true,
                {}
            );
            if (isShowLoader) {
                dispatch(hideLoader());
            }
            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Companies fetching failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateUserCompanies = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserCompanies",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.patch(
                `api/v1/companies/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.companies.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Companies failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const currentUserVerificationData = createAsyncThunk<any, any>(
    "client/currentUserVerificationData",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            console.log(id);

            dispatch(showLoader());
            const response = await HttpService.get(`api/v1/verifications/user/${id}`, true, {});

            dispatch(hideLoader());
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User verification  failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserVerificationData = createAsyncThunk<any, { data: any }>(
    "client/createUserVerificationData",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/verifications",
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.verifications.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User created Verifications failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateUserVerification = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserVerification",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.patch(
                `api/v1/verifications/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.verifications.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Verifications failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getUserNotifications = createAsyncThunk<any, { id: string }>(
    "client/getUserNotifications",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/notification-settings/user/${id}`,

                true,
                {}
            );

            dispatch(hideLoader());

            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }

            // GlobalService.showToast("success", "Success", "User Preferences Updated Successfully");
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Notification settings failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const createUserNotifications = createAsyncThunk<any, { data: any }>(
    "client/createUserNotifications",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/notification-settings",
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.notifications.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User created notifications failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateUserNotifications = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserNotifications",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.patch(
                `api/v1/notification-settings/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.notifications.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Notification failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const getUserPrivacies = createAsyncThunk<any, { id: string }>(
    "client/getUserPrivacies",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/user-privacies/user/${id}`,

                true,
                {}
            );

            dispatch(hideLoader());

            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }

            // GlobalService.showToast("success", "Success", "User Preferences Updated Successfully");
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Privacies settings failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const createUserPrivacies = createAsyncThunk<any, { data: any }>(
    "client/createUserPrivacies",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/user-privacies",
                data,
                { "Content-Type": "application/json" },
                true
            );
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.privacy.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User created Privacies failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const updateUserPrivacies = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserPrivacies",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());
            const response = await HttpService.patch(
                `api/v1/user-privacies/${id}`,
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.privacy.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "User Update Privacies failed";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);
export const createUserJobs = createAsyncThunk<any, { data: any }>(
    "client/createUserJobs",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post("api/v1/jobs", data, { "Content-Type": "application/json" }, true);
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.jobs.created"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("API Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

export const updateUserJob = createAsyncThunk<any, { id: string; data: any }>(
    "client/updateUserJob",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.patch(`api/v1/jobs/${id}`, data, { "Content-Type": "application/json" }, true);
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.jobs.updated"));
            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("API Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

export const deleteUserJob = createAsyncThunk<any, { id: string }>(
    "client/deleteUserJob",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.deleteRecord(`api/v1/jobs/${id}`, { "Content-Type": "application/json" }, true);
            dispatch(hideLoader());

            GlobalService.showToast("success", i18n.t("toast.titles.success"), i18n.t("toast.jobs.deleted"));
            return { id };
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("API Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);
export const getTypeCategories = createAsyncThunk<any, { id: number | string }>(
    "client/getTypeCategories",
    async ({ id }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.get(
                `api/v1/categories/type/${id}`,

                true,
                getLanguageHeaders()
            );

            dispatch(hideLoader());

            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }

            // GlobalService.showToast("success", "Success", "User Preferences Updated Successfully");
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("API Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

export const getClientStats = createAsyncThunk<any, { id: string; isShowLoader?: boolean }>(
    "client/getClientStats",
    async ({ id, isShowLoader = true }, { dispatch, rejectWithValue }) => {
        try {
            if (isShowLoader) {
                dispatch(showLoader());
            }

            const response = await HttpService.get(
                `api/v1/users/client-stats/${id}`,
                true,
                {}
            );

            if (isShowLoader) {
                dispatch(hideLoader());
            }

            if (typeof response == "string" && response.length == 0) {
                return null;
            } else {
                return response;
            }
        } catch (error: any) {
            dispatch(hideLoader());
            const errorData = error?.data?.errors;
            const errorMessage = errorData?.hash || errorData?.email || "Failed to fetch client stats";

            console.log(error);
            return rejectWithValue(errorMessage);
        }
    }
);

export const generateAIDescription = createAsyncThunk<any, { data: any }>(
    "client/generateAIDescription",
    async ({ data }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/jobs/generate-ai-description",
                data,
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("AI Description Generation Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

export const generateAIBio = createAsyncThunk<any, { userId: string; language?: string }>(
    "user/generateAIBio",
    async ({ userId, language }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(showLoader());

            const response = await HttpService.post(
                "api/v1/users/generate-ai-bio",
                { userId, language },
                { "Content-Type": "application/json" },
                true
            );

            dispatch(hideLoader());

            return response;
        } catch (error: any) {
            dispatch(hideLoader());
            const errorMessage = parseApiErrors(error);

            console.log("AI Bio Generation Error:", error);
            GlobalService.showToast("error", i18n.t("toast.titles.error"), errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);
